import React, {Component} from 'react';
import ReserveSpotButton from './ReserveSpotButton';
import UnReserveSpotButton from './UnReserveSpotButton';
import SpotDetailsButton from './SpotDetailsButton';
import SpotReservationNotice from '../../../components/SpotReservationNotice';
import {priceInDollars, userCanReserveOrTradeSpot, checkUserLoggedIn} from './../../../utils';
import { LOCK_PARKING_GROUP_NAME } from './../../../constants';

class ParkingSpotInfoFooter extends Component {

  footerTextByStatus(status, isReservedByMe) {
    if (isReservedByMe) {
      return "Reserved By You";
    } else if (status === "OPEN") {
      return "Available";
    }
    return "Unavailable";
  }

  spotActionButton(spotId, status, isReservedByMe, isReadOnly) {
    if (isReservedByMe) {
      return <UnReserveSpotButton spotId={spotId} isReadOnly={isReadOnly} />;
    } else if (status === "OPEN") {
      return <ReserveSpotButton spotId={spotId} isReadOnly={isReadOnly} />;
    }
  }

  showDetailsButton(status) {
    return this.props.isMobileDevice && ( status !== 'OPEN' );
  }

  showSpotActionButton(spotId, isReservedByMe) {
    const { isReadOnly, isUserLoggedIn, ispreBooked, attendee } = this.props;

    if(isReadOnly) return false;

    // if the spot is locked and I reserved it, don't show the button, which would be the Unreserve button
    const isSpotLockedForAttendee =
      isUserLoggedIn &&
      LOCK_PARKING_GROUP_NAME &&
      attendee &&
      attendee.assignments &&
      attendee.assignments.some(assignment =>
        assignment.group &&
        assignment.group.toLowerCase() === LOCK_PARKING_GROUP_NAME.toLowerCase() &&
        assignment.vehicleNumber === spotId
      );
    if (isSpotLockedForAttendee && isReservedByMe) {
      return false;
    }

    if(isUserLoggedIn) {
      return !ispreBooked && userCanReserveOrTradeSpot();
    }

    return true;
  }

  render() {
    const { spotDetails, spotId, isReservedByMe, status, isReadOnly, isMobileDevice } = this.props;
    const { properties } = spotDetails;
    const { price } = properties;

    return (
      <div className="spot-footer">
        {this.footerTextByStatus(status, isReservedByMe)}

        <div className="pull-right">
          <strong className="color-base">
            { priceInDollars(price) }
          </strong>
        </div>

        <div className="spot-footer-cta">
          { this.showDetailsButton(status) && <SpotDetailsButton isReservedByMe={isReservedByMe} isMobileDevice={isMobileDevice} /> }
          { this.showSpotActionButton(spotId, isReservedByMe) && this.spotActionButton(spotId, status, isReservedByMe, isReadOnly) }
        </div>

        <SpotReservationNotice />
      </div>
    );
  }

}

export default ParkingSpotInfoFooter;



// WEBPACK FOOTER //
// ./src/containers/MapInfoBar/ParkingSpotInfoFooter/index.js